import R from 'ramda';
import { validateObject } from 'common/validation';

const optionsConstraints = {};

const validateOptIn = R.curry((field, optIn, fields, errors) => {
  if (optIn.required && !R.contains(optIn.optInId, fields.acceptedOptIns)) {
    return R.assoc(field, ['Accepting this option is required'], errors);
  }

  if (
    !R.contains(optIn.optInId, fields.acceptedOptIns) &&
    !R.contains(optIn.optInId, fields.declinedOptIns)
  ) {
    return R.assoc(field, ['Please accept or decline this option'], errors);
  }

  return errors;
});

const validateOptIns = R.curry((optIns, fields, errors) =>
  R.addIndex(R.reduce)(
    (errors, optIn, index) =>
      validateOptIn(`optIns[${index}]`, optIn, fields, errors),
    errors,
    optIns,
  ),
);

export const validateOptions = R.curry((optIns, fields) =>
  R.pipe(validateObject(optionsConstraints), validateOptIns(optIns, fields))(
    fields,
  ),
);



// WEBPACK FOOTER //
// ./src/options/optionsValidation.js